// JsFromRoutes CacheKey 11b9efd199f6a99f927a14d8f94f6f47
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@consumer/services/api'

export default {
  searchForCheckout: /* #__PURE__ */ definePathHelper('post', '/consumer/public_user_profiles/search_for_checkout'),
  searchForCalendar: /* #__PURE__ */ definePathHelper('post', '/consumer/public_user_profiles/search_for_calendar'),
  searchForContact: /* #__PURE__ */ definePathHelper('post', '/consumer/public_user_profiles/search_for_contact'),
  show: /* #__PURE__ */ definePathHelper('get', '/u/:username'),
}
